import React from 'react';
import { Group, Loader, Text } from '@mantine/core';

export const LoadingState = React.memo(({ firstLoading, listToRender }: any) =>
  firstLoading && listToRender.length === 0 ? (
    <Group gap="xs">
      <Loader size="sm" />
      <Text c="dimmed" size="sm">
        Loading context…
      </Text>
    </Group>
  ) : null
);
